import React, { CSSProperties } from "react"
import { Toggle } from "material-ui"
import { grey500 } from "material-ui/styles/colors"

interface IProps {
    data_intercom_target?: string
    label: string
    info?: string
    toggled: boolean
    disabled: boolean
    style: CSSProperties
    width?: number
    onToggle(event, value: boolean)
}

const InfoIconToggle: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", ...props.style, width: props.width || 275 }}>
            <div>
                <span>{props.label}</span>
                {props.info &&
                    <i className="fa fa-info-circle" title={props.info} style={{ color: grey500, fontSize: 13, marginLeft: 4 }} />
                }
            </div>
            <div>
                <Toggle
                    data-intercom-target={props.data_intercom_target}
                    toggled={props.toggled}
                    onToggle={props.onToggle}
                    disabled={props.disabled}
                />
            </div>
        </div>
    )
}

export default InfoIconToggle